import { render } from "./FileImportExportView.vue?vue&type=template&id=73b8d1fe&scoped=true"
import script from "./FileImportExportView.vue?vue&type=script&lang=js"
export * from "./FileImportExportView.vue?vue&type=script&lang=js"

import "./FileImportExportView.vue?vue&type=style&index=0&id=73b8d1fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b8d1fe"]])

export default __exports__